import { createContext } from "react";

import { flagg } from "../core/core";
import { inMemoryStore } from "../store/in-memory-store";

export const FlaggContext = createContext({
  featureFlags: flagg({ store: inMemoryStore() }),
  iteration: 0,
});
